import {createSlice, freeze, PayloadAction, Reducer} from '@reduxjs/toolkit';

import {TableStoreState, VolatileTableState} from 'notebook/tables/state/TableState';
import {SliceActions} from 'redux-stores/Action';

export interface StructuredTableStoreState {
  tables: {
    [tableKey: string]: TableStoreState;
  };
}

export function getTableStateKey(fileId: string, provenanceUuidOrName: string): string {
  return `${fileId}:${provenanceUuidOrName}`;
}

interface BaseTableAction {
  tableKey: string;
}

interface SetTableDataAction extends BaseTableAction {
  volatileTableState: VolatileTableState;
}

export const StructuredTableStore = createSlice({
  name: 'tableStore',
  initialState: {tables: {} as {[tableKey: string]: TableStoreState}},
  reducers: {
    setVolatileTableData: (state, action: PayloadAction<SetTableDataAction>) => {
      // Freeze this object to prevent immer from having to parse it.
      const frozenState = freeze(action.payload.volatileTableState);
      if (!state.tables[action.payload.tableKey]) {
        state.tables[action.payload.tableKey] = {volatileState: frozenState};
      } else {
        state.tables[action.payload.tableKey].volatileState = frozenState;
      }
    },
    removeTable: (state, action: PayloadAction<BaseTableAction>) => {
      delete state.tables[action.payload.tableKey];
    },
  },
});

export type StructuredTableStoreActions = SliceActions<typeof StructuredTableStore.actions>;

export const StructuredTableStoreReducer = StructuredTableStore.reducer as Reducer<
  StructuredTableStoreState,
  StructuredTableStoreActions
>;
